<template>
	<main>
		<Content>
			<template>
				<GuidesContent/>
			</template>
		</Content>
	</main>
</template>

<script>
	import Content from '@/components/Content';
	import GuidesContent from '@/components/content/GuidesContent'

	export default {
		name: 'Guides',
		components: {
			Content,
			GuidesContent,
		}
	}
</script>
